import bulkActionAddTag from './bulk-action-add-tag';
import bulkActionApplyTm from './bulk-action-apply-tm';
import bulkActionCopyKeys from './bulk-action-copy-keys';
import bulkActionDeleteKey from './bulk-action-delete-key';
import bulkActionFillText from './bulk-action-fill-text';
import bulkActionMoveKeys from './bulk-action-move-keys';
import bulkActionRemoveTag from './bulk-action-remove-tag';
import bulkActionRestoreTranslation from './bulk-action-restore-translation';
import bulkActionReview from './bulk-action-review';
import bulkActionUnReview from './bulk-action-unreview';
import type { Handler } from './common';

const handlers = {
    'bulk-action-add-tag': bulkActionAddTag,
    'bulk-action-remove-tag': bulkActionRemoveTag,
    'bulk-action-delete-key': bulkActionDeleteKey,
    'bulk-apply-tm': bulkActionApplyTm,
    'bulk-action-copy-keys': bulkActionCopyKeys,
    'bulk-action-move-keys': bulkActionMoveKeys,
    'bulk-action-review': bulkActionReview,
    'bulk-action-unreview': bulkActionUnReview,
    'bulk-action-fill-text': bulkActionFillText,
    'bulk-action-restore-translation': bulkActionRestoreTranslation,
};

export type { Handler };
export type HandlerType = keyof typeof handlers;

export const getHandler = (type: string): Handler | null => handlers[type as HandlerType] ?? null;
